import { Box, Stack, Typography } from "@mui/material";
import ChartTooltip from "components/Dashboard/ChartTooltip";
import { useMemo } from "react";
import { ThresholdWithDisplay } from "./hooks/useWasteThresholds";

export function ThresholdTooltip({
  thresholds,
  hoveredThresholdValue,
}: {
  thresholds: Array<ThresholdWithDisplay>;
  hoveredThresholdValue?: string | null;
}) {
  const tooltipTitle = "Generator Thresholds";
  const tooltipChildren = useMemo(() => {
    // Sort thresholds by their threshold value (ascending)
    const sortedThresholds = [...thresholds].sort((a, b) => {
      return b.threshold - a.threshold;
    });

    return (
      <Stack direction="column" gap={1}>
        {sortedThresholds.map((threshold) => {
          // Check if this threshold's value matches the hovered threshold value
          const isHovered =
            hoveredThresholdValue === threshold.threshold.toString();

          return (
            <Stack
              direction="row"
              gap={0.5}
              key={threshold.id}
              alignItems="center"
            >
              <Box
                sx={{
                  width: 20,
                  height: 2,
                  display: "inline-block",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "2px",
                    background: `repeating-linear-gradient(to right, ${threshold.color} 0, ${threshold.color} 3px, transparent 2px, transparent 5px)`,
                  },
                }}
              />
              <Typography variant="body2" fontWeight={isHovered ? 700 : 400}>
                {threshold.name}
              </Typography>
              <Typography variant="body2" fontWeight={isHovered ? 700 : 400}>
                {`(${threshold.displayValue})`}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    );
  }, [thresholds, hoveredThresholdValue]);

  return <ChartTooltip title={tooltipTitle}>{tooltipChildren}</ChartTooltip>;
}
